import {LiveStreamingItemContainerDefaultBox} from "./live-streaming-item-container.default.box";

export const LiveStreamingItemContainerBox = LiveStreamingItemContainerDefaultBox;
